import { useEffect, useState, useMemo, useContext } from "react";
import useAxios from "../../services/useAxios";
import ProductListShop from "../../components/ShopPage/productList/ProductListShop/ProductListShop";
import { useParams, NavLink, useNavigate } from "react-router-dom";
import ProductCard from "../../components/common/ProductCard/ProductCard";
import useWindowSize from "../../hooks/useWindowSize";
import { ArrowRightIcon } from "../../components/kits/Icons/Icons";
import styleColor from "../../assets/kits/colors/colors.module.scss";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext";
import { pathMaker } from "../../utilities/helperFunctions";
import CartItemBtn from "../../components/cartitem/CartitemBtn";

const FilterProduct = () => {
  const {
    getItemCountPerShop,
    changeShoppingCartItemCount,
    shoppingListItemsFinalState,
  } = useContext(ShoppingCartItemContext);
  const { execute: config_filter } = useAxios("api/config_filter");
  const [configsProduct, setConfigsProduct] = useState([]);
  const [shopISOpen, setShopISOpen] = useState(true);
  const { index, shopId, title } = useParams();
  const { width, height } = useWindowSize();
  const navigate = useNavigate();
  const [click, setClick] = useState(false);
  const shoppingCartState = shoppingListItemsFinalState;
  const count = getItemCountPerShop(shopId);
  const { getItemsShop } = useContext(ShoppingCartItemContext);
  const shoppingCartData = getItemsShop(shopId);
  // const [shopInfo, setShopInfo] = useState({
  //   cover_file: [],
  //   supplier: [],
  //   logo_file: [],
  //   supplier_line_links: [],
  // });
  const { loading, execute: ShopInfoApi } = useAxios(
    "superadminapi/get_edit_suppliers_data",
    { supplier_id: shopId }
  );

  const ShopInfoFunc = async () => {
    await ShopInfoApi().then((data) => {
      // setShopInfo(data);
      situationShopFunc(
        data?.supplier[0]?.start_hour,
        data?.supplier[0]?.start_min,
        data?.supplier[0]?.finish_hour,
        data?.supplier[0]?.finish_min,
        data?.supplier[0]?.main_status,
        data
      );
    });
  };

  const situationShopFunc = (
    startHour,
    startMin,
    finishHour,
    finishMin,
    status,
    shopInfo
  ) => {
    function addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    }
    let currentHour = addZero(new Date().getHours());
    let currentMin = addZero(new Date().getMinutes());

    if (
      (startHour != "" && currentHour < startHour) ||
      (finishHour != "" && currentHour > finishHour) ||
      (startHour != "" && currentHour == startHour && currentMin < startMin) ||
      (finishHour != "" &&
        currentHour == finishHour &&
        currentMin > finishMin) ||
      status != 0 ||
      shopInfo?.supplier_line_links?.length == 0
    ) {
      setShopISOpen(false);
    } else if (
      (startHour != "" &&
        currentHour > startHour &&
        finishHour != "" &&
        currentHour < finishHour) ||
      (startHour != "" &&
        currentHour == startHour &&
        currentMin > startMin &&
        finishHour != "" &&
        currentHour < finishHour) ||
      (finishHour != "" &&
        currentHour == finishHour &&
        currentMin < finishMin &&
        startHour != "" &&
        currentHour > startHour) ||
      finishHour == "" ||
      startHour == ""
    ) {
      setShopISOpen(true);
    }
  };

  const productCardWidth = useMemo(() => {
    return width >= 445 ? 130 : width >= 375 ? 160 : 130;
  }, [width]);

  useEffect(() => {
    ShopInfoFunc();

    let form = new FormData();
    form.append("supplierId", shopId);
    form.append("configIndex", index);
    let getProduct = configsProduct;
    config_filter(form).then((products) => {
      getProduct.push({
        title: title,
        items: products.items,
      });
      setConfigsProduct(getProduct);
    });
  }, []);

  return (
    <>
      {configsProduct.length > 0 && (
        <div className="mr-b-68">
          {" "}
          <div className="mr-t-16">
            <div
              className="d-flex pd-x-20 pd-y-12 mr-b-12 align-items-center"
              style={{ color: styleColor.gray_900 }}
            >
              <button
                onClick={() => navigate(-1)}
                className="btn mr-0 pd-x-0 pd-t-0 pd-b-2"
                style={{ color: styleColor.gray_900 }}
              >
                <ArrowRightIcon />
              </button>
              <span className="title-h3-b mr-r-8">{title}</span>
            </div>
            {/* <div className="d-flex justify-content-between mr-b-12   ">
              <div className="title-h4-m mr-r-20">{title}</div>
            </div> */}
          </div>
          <div className="mr-r-14 pd-b-12 d-flex flex-wrap">
            {configsProduct.length > 0 &&
              configsProduct[0].items.map((value, index) => {
                return (
                  <div className="mr-x-6">
                    <ProductCard
                      title={value.title}
                      link={`/product/${shopId}/${value.avb_product_for_order__id}`}
                      price={value.price}
                      cartItemCount={
                        count[`apoId_${value.avb_product_for_order__id}`]
                      }
                      imagePath={pathMaker(value.imagePath)}
                      key={`product-card-${index}`}
                      disabled={!shopISOpen}
                      discount={value.discount}
                      // disableOnClick={() => {
                      //   if (!shopIsOpen) {
                      //     setIsOpenDrawerClose(true);
                      //   }
                      // }}
                      plusOnClick={() => {
                        setClick(true);
                        changeShoppingCartItemCount(
                          "add",
                          "",
                          value.total_inventory_count,
                          value.min_order_count,
                          getItemCountPerShop(shopId)[
                            `apoId_${value.avb_product_for_order__id}`
                          ],
                          "1",
                          value.price,
                          value.avb_product_for_order__id,
                          value.title,
                          shopId
                        );
                      }}
                      minusOnClick={() => {
                        changeShoppingCartItemCount(
                          "reduce",
                          "",
                          value.total_inventory_count,
                          value.min_order_count,
                          "",
                          "1",
                          value.price,
                          value.avb_product_for_order__id,
                          value.title,
                          shopId
                        );
                      }}
                      width={productCardWidth}
                      loading={
                        shoppingCartState[
                          `state-${value.avb_product_for_order__id}`
                        ] == true
                          ? true
                          : false
                      }
                    />
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {shoppingCartData.items?.length > 0 && (
        <CartItemBtn
          isOpen2={shoppingCartData.items?.length > 0}
          shopId={shopId}
        />
      )}
    </>
  );
};

export default FilterProduct;
